<div *ngIf="!showLoader && render && !showTourNotavailable" [className]="!renderConfirm && !hidePage ? 'flex justify-center h-full' : 'hidden'">
  <div class="flex flex-col justify-center w-full sm:w-3/4">
    <h2 class="text-4xl my-2 use-rhetorik-sans">Sign In</h2>
      <div class="flex items-center my-2">
        <div class="text-gray-tricon">Don't have an account?</div>
        <button class="mx-2" mat-button color="accent"  (click)="onRegisterClick()">CREATE ACCOUNT</button>
      </div>
    <form id="loginForm" #loginForm="ngForm" (ngSubmit)="onSubmit()" class="flex flex-col justify-center mt-2">
      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Email Address</mat-label>
        <input matInput name="Email" id="Email" required email [(ngModel)]="model.Email" #Email="ngModel">
        <mat-error>
          Please enter a valid email address
        </mat-error>
      </mat-form-field>
      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Password</mat-label>
        <input matInput [type]="hide ? 'password' : 'text'" name="Password" id="Password" required [(ngModel)]="model.Password" #Password="ngModel">
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>
      <re-captcha size="invisible" #invisible></re-captcha>
      <button mat-flat-button color="primary" type="submit" class="my-2">SIGN IN</button>
    </form>
    <div class="flex justify-center font-bold my-1 lg:ml-8 ml-0 flex-col sm:ml-0 lg:flex-row ">
      <button class="self-center" mat-button color="accent" [routerLink]="['/public/forgotEmail']" style="color: #545859">FORGOT YOUR EMAIL?</button>
      <button class="self-center mt-3 ml-0 lg:ml-10 lg:mt-0" mat-button color="accent" [routerLink]="['/forgot']" style="color: #545859">FORGOT YOUR PASSWORD?</button>
    </div>
    <div class="flex justify-center text-gray-self-tour font-bold my-4 lg:my-">
      OR
    </div>
    <button mat-flat-button color="accent" (click)="onGoogleSignIn()">
      <div class="flex justify-center items-center">
        <svg class="h-6 w-6" viewBox="0 0 533.5 544.3" xmlns="http://www.w3.org/2000/svg">
          <path d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z" fill="#4285f4"/>
          <path d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z" fill="#34a853"/>
          <path d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z" fill="#fbbc04"/>
          <path d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z" fill="#ea4335"/>
        </svg>
        <div class="ml-2">
          CONTINUE WITH GOOGLE
        </div>
      </div>
    </button>
    <button class="mt-3" mat-flat-button color="accent" (click)="onAppleSignIn()">
      <div class="flex justify-center items-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mb-1 apple-logo" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1000 1000">
          <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.6-57-155.5-127C46.7 790.7 0 663 0 541.8c0-194.4 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z"/>
        </svg>
        <div class="ml-2">
          CONTINUE WITH APPLE
        </div>
      </div>
    </button>
    <div class="flex justify-center items-center" style="padding-top: 10px;">
      By signing in, you consent to receive electronic messages from Tricon, including invitations to programs and events, as well as legal updates and other notifications.
    </div>
  </div>
</div>
<div *ngIf="renderConfirm" class="h-full"><router-outlet></router-outlet></div>
<div *ngIf="showTourNotavailable" class="flex flex-col items-center">
  <div class="sm:w-3/4 flex flex-col items-center">
    <div class="my-2 text-center">Self Tour Unavailable</div>
    <div class="my-2 text-center">The self tour option for this home is currently unavailable. We apologize for the inconvenience.</div>
    <div class="my-2 text-center">For further assistance please contact our Customer Support Team @ <a href="tel:{{triconPhone}}"><u>{{triconPhoneDotFormat}}</u></a>.</div>
    <div class="my-2 text-center">The team is available Monday-Friday from 5am-6pm PST and Saturday/Sunday 6am-2:30pm PST.</div>
  </div>

</div>
<div *ngIf="showLoader" class="flex flex-col items-center">
  <div class="sm:w-3/4 flex flex-col items-center">
    <div class="my-2 text-center">Thank You For Your Patience</div>
    <div class="mt-2 mb-8 text-center">{{loadingText}}</div>
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
</div>
